module.exports = __webpack_public_path__ + "triangle.ae70e480.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/triangle.svg
// module id = GMOP
// module chunks = 0